export { default as HotelTopSpending } from "./HotelTopSpending";
export { Top5PropertiesTransactionsResultSchema } from "./types";
export type { Top5PropertiesTransactionsResult } from "./types";
